

var mainWrapper = document.getElementById('main');
var windowHeight = window.innerHeight; 
var windowWidth = window.innerWidth; 
var cartData = { cart: '',extra: '' };
var upsellProductComparePrice = 0;
var upsellProductID;


// ************ toggle mobile menu ************ 

//var burgerMenu = document.getElementById('burgerMenu');
var headerBar = document.getElementById('headerBar');

//burgerMenu.addEventListener("click", toggleMenu);


function toggleMenu(){
	if(headerBar.classList.contains('menu-active')){
		headerBar.classList.remove("menu-active");
	} else{
		headerBar.classList.add("menu-active");
	}
}




// ************ show promobar on load ************ 
// var hidePromobar = localStorage.getItem("hidePromobar");
var promobar = document.getElementById('promobar');
var promobarCloseBtn = document.getElementById('promobarClose');

// if(hidePromobar == '' || hidePromobar == null){
// 	promobar.classList.add("promo-active");
// 	mainWrapper.classList.add("promo-active");
// } else{
// 	var now = new Date();
// 	var old = new Date(hidePromobar);
// 	var timeDifference = Math.round((now.getTime() - old.getTime())/1000);
// 	if(timeDifference >= 3600){
// 		promobar.classList.add("promo-active");
// 		mainWrapper.classList.add("promo-active");
// 		localStorage.removeItem("hidePromobar");
// 	} else{
// 		//console.log(Math.round(((3600-timeDifference)/60)) + ' Minutes left.');
// 	}
// }

if(promobar && promobarCloseBtn){
  promobarCloseBtn.addEventListener("click", closePromobar);
}


// ************ close promobar ************ 
function closePromobar(){
	promobar.classList.remove("promo-active");
	mainWrapper.classList.remove("promo-active");
	//localStorage.setItem("hidePromobar", new Date());
}





/* ************ show header cta on scroll ************ 
var headerCTA = document.getElementById('headerCTA');
var headerCTAvisible = false;

if(!$('body').hasClass('template-product')){
  window.addEventListener('scroll', function(e) {
  	if(scrollY > (windowHeight - 100)){

  		if (!headerCTAvisible) {
  			headerCTA.style.display = 'flex';
  			headerCTAvisible = true;
  		}
  	} else{
  		if (headerCTAvisible) {
  			headerCTA.style.display = 'none';
  			headerCTAvisible = false;
  		}
  	}
  });
}
*/



// ************ scroll down function ************ 
function scrollDown(){
	$('html, body').animate({
	    scrollTop: windowHeight - 100
  	});
}



// ***** on resize event listener to update some variabls
window.addEventListener('resize', function(e) {
	windowHeight = window.innerHeight;
  windowWidth = window.innerWidth;
});


$(document).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 100
    }, 2000);
});



// ************ scroll down function ************ 
$('.accordion__title').each(function() {
    var acc = $(this);
    
    acc.click(function(){
      var accContent = acc.next();
      if($(this).hasClass('active')){

        if ($(this).closest( ".accordion__content" )){
          console.log('close');
          var contentHeight = accContent.find('.accordion__content__inner').height();
          var parentHeight = $(this).closest( ".accordion__content" ).height();
          $(this).closest( ".accordion__content" ).animate({height:parentHeight-contentHeight},200);
        }
        accContent.animate({height:0},200);
        $(this).removeClass('active');

        

      } else{
        var contentHeight = accContent.find('.accordion__content__inner').height();
        accContent.animate({height:contentHeight},200);

        if ($(this).closest( ".accordion__content" )){
          console.log('paaarent');
          var parentHeight = $(this).closest( ".accordion__content" ).height();
          $(this).closest( ".accordion__content" ).animate({height:contentHeight+parentHeight},200);
        }
        $(this).addClass('active');
      }    

    })
});


// ************ copy discount code ************ 

function copyCode(code) {
  var btnSpan = $('#copyDiscountCode');

  var btnHtml = btnSpan.html();
  var $temp = $("<input>");
  $("body").append($temp);
  $temp.val(code).select();
  document.execCommand("copy");
  $temp.remove();

  btnSpan.html('Code kopiert!');
  btnSpan.addClass('copied');
  setTimeout(function(){
    btnSpan.html(btnHtml);
    btnSpan.removeClass('copied');
  },700);
}



// ************ ajax card functions ************ 
rivets.formatters.currency = function(value){
  return (value / 100).toFixed(2) + '€';
}

rivets.formatters.installment = function(value){


  var installment = ((value/100)*1.05143298969)/12;
      installment = Math.round((installment + Number.EPSILON) * 100) / 100;
 
 // var installment = value / 100 / 12;
  // installment = Math.round((installment + Number.EPSILON) * 100) / 100;
  // if(installment * 12 < value){
  //   installment = installment + 0.01;
  // }

  installment = installment.toLocaleString("en", {useGrouping: false, minimumFractionDigits: 2});
  installment = installment.replace(".", ",");
  return installment + '€';
}

rivets.formatters.scooter = function(value){
  if(value == parseInt($('#upsellProductID').val())){
    return false;
  } else{
    return true;
  }
}

rivets.formatters.eq = function(value, args)
{
  return value === args;
};

rivets.formatters.incart = function(value,args){
  if(value && args){
    var upsellid = args; 

    for (var i = value.length - 1; i >= 0; i--) {
      if(value[i].variant_id == upsellid){
        return false;
      }
    }
    return true;
  } else{
    return false;
  }
}

rivets.bind($('#drawer'), cartData);

function addToCart(productId,quantity,currency,price,sku,name){


  //console.log(productId+', '+quantity+', '+currency+', '+price+', '+sku+', '+name);

  localStorage.setItem('myGoComparePrice',$('#myGoComparePrice').val());
  var customizerUpsell = '';
  if($('#addToCart').data('add')){
    var customizerUpsell = $('#addToCart').data('add');
  }
  //console.log('addToCart: '+ customizerUpsell);
  if(customizerUpsell != ''){
     // add item to cart
    $.post('/cart/add.js', {
      items: [
        {
          quantity: quantity,
          id: productId,
        },
        {
          quantity: 1,
          id: customizerUpsell,
        }
      ]
    },null,"json")
    .done(function(data) {
      ga('send', {
        hitType: 'event',
        eventLabel: productId,
        eventAction: 'Add to cart',
        eventCategory: ''
      });

      dataLayer.push({
        'event': 'addToCart',
        'ecommerce': {
          'currencyCode': currency,
          'add': {                                // 'add' actionFieldObject measures.
            'products': [{                        //  adding a product to a shopping cart.
              'name': name,
              'id': productId,
              'sku': sku,
              'price': price,
              'brand': 'myTIER',
              'quantity': 1
             }]
          }
        }
      });

      dataLayer.push({
        event: 'pageview',
        page: {
          path: '/cart',
          title: 'Cart'
        }
      });

      $('#headerCTA').hide();
      $('#showCart').show();
      // open cart
      openCart();
    })
    .fail(function(error) {
      console.log(error);
      console.log('failed added');
    });
  } else{
    // add item to cart
    $.post('/cart/add.js', {
      items: [
        {
          quantity: quantity,
          id: productId,
        }
      ]
    },null,"json")
    .done(function(data) {
      ga('send', {
        hitType: 'event',
        eventLabel: productId,
        eventAction: 'Add to cart',
        eventCategory: ''
      });

      dataLayer.push({
        'event': 'add_to_cart',
        'ecommerce': {
          'currencyCode': currency,
          'add': {                                // 'add' actionFieldObject measures.
            'products': [{                        //  adding a product to a shopping cart.
              'name': name,
              'id': productId,
              'sku': sku,
              'price': price,
              'brand': 'myTIER',
              'quantity': 1
             }]
          }
        }
      });

      dataLayer.push({
        event: 'pageview',
        page: {
          path: '/cart',
          title: 'Cart'
        }
      });

      $('#headerCTA').hide();
      $('#showCart').show();
      // open cart
      openCart();
    })
    .fail(function(error) {
      console.log(error);
      console.log('failed added');
    });
  }
   

};

function toggleInstallmentInfo(info){
  if(info.total_price > 10000){
    $('.js-show-if-installment').show();
  } else{
    $('.js-show-if-installment').hide();
  }
};

function closeCart(){
  document.body.classList.remove("cart-open");
};

function openCart(isScooterPage) {

  // Hotjar cart trigger
  hj('trigger', 'cart');

  // Anayltics /cart tragger
  ga('set', 'page','/cart');
  ga('send', 'pageview');

  dataLayer.push({
    event: 'pageview',
    page: {
      path: '/cart',
      title: 'Cart'
    }
  });

  // if(isScooterPage){
  //   console.log('set compare price');
  //   localStorage.setItem('myGoComparePrice',$('#myGoComparePrice').val());
  // }
  $.getJSON( '/cart.js', function(data) {
    var upsellProducts = 0;
    var extra = {};
    cartData.extra = extra;
    cartData.cart = data;

    toggleInstallmentInfo(data);
      

    // data['myGoComparePrice'] = parseInt(localStorage.getItem('myGoComparePrice'));
    // extra['cartOriginal'] = data.myGoComparePrice;

    // upsellProductComparePrice = parseInt($('#upsellProductComparePrice').val());
    // upsellProductID = parseInt($('#upsellProductID').val());

    // for (var i = data.items.length - 1; i >= 0; i--) {
    //   if(data.items[i].variant_id == upsellProductID){
    //     upsellProducts = data.items[i].quantity;
    //     var upsellDiscount = upsellProducts * upsellProductComparePrice;
    //     extra['cartOriginal'] = extra['cartOriginal'] + upsellDiscount;
    //   }
    // }
    // cartData.extra.cartSavings

    // data['upsellProducts'] = upsellProducts;
    // extra['cartSavings'] = (data.items_subtotal_price - extra.cartOriginal) * -1;

    
    // if(localStorage.getItem('discount')){
    //   showDiscount(data,'',localStorage.getItem('discount'));
    // } 
    

    document.body.classList.add("cart-open");
  });
};


function updateCart(newOriginal) {
  $.getJSON( '/cart.js', function(data) {


    var upsellProducts = 0;
    for (var i = data.items.length - 1; i >= 0; i--) {
      if(data.items[i].variant_id == upsellProductID){
        upsellProducts = data.items[i].quantity;
      }
    }
    data['upsellProducts'] = upsellProducts;
    data['myGoComparePrice'] = localStorage.getItem('myGoComparePrice');

    if(newOriginal){
      cartData.extra.cartOriginal = newOriginal;
      cartData.extra.cartSavings = (data.items_subtotal_price - newOriginal) * -1;
    }

    if(localStorage.getItem('discount')){
      showDiscount(data,'dataonly',localStorage.getItem('discount'));
    } else{
      cartData.cart = data;
      cartLoading(false);
    }
    
    toggleInstallmentInfo(data);
  });
};





function setQuantity(e,type){
  var productId = e.dataset.id;
  var currentCount = parseInt($('.cart__item__info__quantity__count[data-id="'+productId+'"]').text());
  cartLoading(true, $('.cart__item[data-id="'+productId+'"] .cart__item__info__quantity'));


  if(type == 'add'){
    $.post('/cart/add.js', {
      items: [
        {
          quantity: 1,
          id: productId,
        }
      ]
    },null,"json")
    .done(function(data) {
      var newOriginal = cartData.extra.cartOriginal + upsellProductComparePrice;
      updateCart(newOriginal);
      cartLoading(false, $('.cart__item[data-id="'+productId+'"] .cart__item__info__quantity'));
    })
    .fail(function(error) {
      console.log(error);
      console.log('failed added');
    });
  }
  if(type == 'remove'){
    $.post('/cart/change.js', {
      quantity: currentCount-1,
      id: productId,     
    },null,"json")
    .done(function(data) {
      if(currentCount-1 == 0){
        removeDiscount();
        $('#addToCart').show();
        $('#showCart').hide();
      }
      var newOriginal = cartData.extra.cartOriginal - upsellProductComparePrice;
      updateCart(newOriginal);
      cartLoading(false, $('.cart__item[data-id="'+productId+'"] .cart__item__info__quantity'));
    })
    .fail(function(error) {
      console.log(error);
      console.log('failed added');
    });
  }
}


function removeZoom(){
  $('#zoom-popup').remove();
}
function zoomSlick(id){
  var slider = $('#'+id);

  var zoomImg = slider.find('.slick-current').find('img').data('zoom');
  var defaultImg = slider.find('.slick-current').find('img').data('default');

  $('body').append('<div id="zoom-popup" class="zoom-popup"><button class="zoom-popup__close" onclick="removeZoom()">✕</button><div class="zoom-img"  id="zoom-popup__img" data-zoom="'+zoomImg+'"><img src="'+defaultImg+'" class="zoom-bg"  /></div><svg width="45" height="67" viewBox="0 0 45 67" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.5" d="M8.2942 32.2182C8.6067 32.4526 8.99827 32.5557 9.38565 32.5058C9.77303 32.4559 10.1257 32.2569 10.3686 31.9511C10.6115 31.6452 10.7256 31.2567 10.6865 30.8681C10.6474 30.4794 10.4583 30.1214 10.1594 29.87C8.08314 28.2333 6.51278 26.0422 5.63001 23.5501C4.74724 21.0581 4.58814 18.367 5.17112 15.7883C5.7541 13.2096 7.05532 10.8487 8.92423 8.97873C10.7931 7.10878 13.1533 5.80622 15.7317 5.2218C18.3101 4.63737 21.0012 4.79496 23.4938 5.67633C25.9863 6.5577 28.1783 8.12683 29.8162 10.2021C31.4541 12.2774 32.4709 14.7741 32.7489 17.4032C33.0269 20.0323 32.5548 22.6864 31.3872 25.0584C31.2851 25.2375 31.221 25.4358 31.199 25.6408C31.1769 25.8458 31.1973 26.0531 31.259 26.2498C31.3207 26.4466 31.4222 26.6285 31.5573 26.7842C31.6924 26.94 31.8582 27.0662 32.0443 27.155C32.2303 27.2438 32.4327 27.2933 32.6388 27.3004C32.8448 27.3074 33.0501 27.272 33.2419 27.1962C33.4336 27.1204 33.6076 27.0059 33.7531 26.8598C33.8986 26.7137 34.0124 26.5392 34.0875 26.3472C35.4991 23.4634 36.0652 20.2389 35.7203 17.0468C35.3754 13.8547 34.1336 10.8255 32.1386 8.30989C30.1437 5.79423 27.4771 3.89495 24.4475 2.83188C21.4179 1.7688 18.1492 1.58538 15.0197 2.30287C11.8902 3.02035 9.02792 4.60939 6.76403 6.88607C4.50014 9.16276 2.92726 12.034 2.22743 15.1675C1.5276 18.301 1.72944 21.5686 2.80958 24.5921C3.88971 27.6156 5.80399 30.2715 8.33086 32.2523L8.2942 32.2182Z" fill="#69D2AA"/><path d="M40.13 35.9H40C39.3541 35.8989 38.7147 36.0282 38.12 36.28C38.0534 35.4599 37.7767 34.6707 37.3165 33.9886C36.8563 33.3064 36.2281 32.7544 35.4925 32.3856C34.757 32.0168 33.9388 31.8437 33.1169 31.883C32.2949 31.9223 31.497 32.1727 30.8 32.61C30.2136 31.6046 29.2812 30.8471 28.177 30.479C27.0728 30.1109 25.8724 30.1575 24.8 30.61V24C24.8 22.7177 24.2906 21.4879 23.3839 20.5812C22.4771 19.6744 21.2473 19.165 19.965 19.165C18.6827 19.165 17.4529 19.6744 16.5461 20.5812C15.6394 21.4879 15.13 22.7177 15.13 24V41.83L14.92 41.51L14.82 41.37C14.414 40.8768 13.9124 40.4707 13.3454 40.1762C12.7785 39.8817 12.1579 39.7049 11.5208 39.6563C10.8838 39.6077 10.2435 39.6884 9.6385 39.8936C9.03345 40.0987 8.47612 40.424 7.99999 40.85C7.12219 41.6466 6.57317 42.742 6.46035 43.922C6.34753 45.1019 6.67903 46.2816 7.38999 47.23L18 63.84V64.73C18 65.1279 18.158 65.5094 18.4393 65.7907C18.7206 66.072 19.1022 66.23 19.5 66.23H39.38C39.7778 66.23 40.1593 66.072 40.4407 65.7907C40.722 65.5094 40.88 65.1279 40.88 64.73V63.88L44.69 58.52C44.8716 58.2662 44.9694 57.9621 44.97 57.65V40.73C44.9673 39.4481 44.4562 38.2196 43.5489 37.3141C42.6415 36.4086 41.4119 35.9 40.13 35.9ZM42 57.17L38.19 62.53C38.0084 62.7838 37.9106 63.088 37.91 63.4V63.23H21V63.4C20.9992 63.1126 20.9159 62.8314 20.76 62.59L9.75999 45.59L9.67999 45.48C9.4137 45.1159 9.29832 44.6629 9.35795 44.2157C9.41757 43.7686 9.64759 43.3617 9.99999 43.08C10.1706 42.9274 10.3696 42.8099 10.5856 42.7344C10.8017 42.6588 11.0305 42.6266 11.259 42.6396C11.4876 42.6526 11.7113 42.7106 11.9173 42.8102C12.1234 42.9098 12.3078 43.049 12.46 43.22L15.37 47.76C15.5455 48.0317 15.8041 48.2394 16.1073 48.3521C16.4105 48.4649 16.742 48.4765 17.0524 48.3854C17.3628 48.2944 17.6354 48.1054 17.8296 47.8467C18.0238 47.588 18.1292 47.2735 18.13 46.95V24C18.13 23.5134 18.3233 23.0466 18.6675 22.7025C19.0116 22.3584 19.4783 22.165 19.965 22.165C20.4517 22.165 20.9184 22.3584 21.2625 22.7025C21.6067 23.0466 21.8 23.5134 21.8 24V42.24C21.8 42.6378 21.958 43.0194 22.2393 43.3007C22.5206 43.582 22.9022 43.74 23.3 43.74C23.6978 43.74 24.0794 43.582 24.3607 43.3007C24.642 43.0194 24.8 42.6378 24.8 42.24V35.07C24.8 34.5834 24.9933 34.1166 25.3375 33.7725C25.6816 33.4284 26.1483 33.235 26.635 33.235C27.1217 33.235 27.5884 33.4284 27.9325 33.7725C28.2767 34.1166 28.47 34.5834 28.47 35.07V42.24C28.47 42.6378 28.628 43.0194 28.9093 43.3007C29.1906 43.582 29.5722 43.74 29.97 43.74C30.3678 43.74 30.7493 43.582 31.0307 43.3007C31.312 43.0194 31.47 42.6378 31.47 42.24V36.71C31.47 36.2233 31.6633 35.7566 32.0075 35.4125C32.3516 35.0684 32.8183 34.875 33.305 34.875C33.7917 34.875 34.2584 35.0684 34.6025 35.4125C34.9467 35.7566 35.14 36.2233 35.14 36.71V44.5C35.14 44.8978 35.298 45.2794 35.5793 45.5607C35.8606 45.842 36.2422 46 36.64 46C37.0378 46 37.4194 45.842 37.7007 45.5607C37.982 45.2794 38.14 44.8978 38.14 44.5V42.8C38.14 42.8 38.14 42.8 38.14 42.73V40.73C38.14 40.4872 38.1883 40.2467 38.2821 40.0227C38.3759 39.7987 38.5134 39.5956 38.6865 39.4253C38.8597 39.255 39.065 39.1208 39.2905 39.0306C39.516 38.9404 39.7572 38.896 40 38.9H40.17C40.6553 38.9 41.1208 39.0928 41.464 39.436C41.8072 39.7792 42 40.2447 42 40.73V57.17Z" fill="#69D2AA"/></div>')
   
   $('#zoom-popup__img')
    .wrap('<span style="display:inline-block"></span>')
    .css('display', 'block')
    .parent()
    .zoom({
      url: $(this).find('img').attr('data-zoom')
    });


}


function cartLoading(loading,element){
  
  if(element){
    if(loading){
      element.addClass('loading');
    } else{
      element.removeClass('loading');
    }
  } else{
    if(loading){
      $('#drawer').addClass('loading');
    } else{
      $('#drawer').removeClass('loading');
    }
  }
}       


function applyDiscount(e){      
  e.preventDefault(); 
  cartLoading(true);
  var theDiscount = $('#devPromo').val();
  theDiscount = theDiscount.toLowerCase();

  if (theDiscount != ''){
    if(theDiscount == 'go50'){


        var smartPhoneActive = false;
        var scooterActive = false;
        for (var i = cartData.cart.items.length - 1; i >= 0; i--) {
          if(cartData.cart.items[i].variant_id == '32801991393355'){
            smartPhoneActive = true;
          }
          if(cartData.cart.items[i].variant_id == '32700172075083'){
            scooterActive = true;
          }
        }
        if(scooterActive){
          if(smartPhoneActive){
            $.post('/cart/change.js', {
              quantity: 1,
              id: 32801991393355,     
            },null,"json")
            .done(function(data) {
              localStorage.setItem('discount', theDiscount);

              $.getJSON( '/cart.js', function(data) {
                showDiscount(data,'',theDiscount);
              });
            })
            .fail(function(error) {
              console.log(error);
              console.log('failed added');
            });
          } else{

            $.post('/cart/add.js', {
              items: [
                {
                  quantity: 1,
                  id: 32801991393355,
                }
              ]
            },null,"json")
            .done(function(data) {
              localStorage.setItem('discount', theDiscount);

              $.getJSON( '/cart.js', function(data) {
                showDiscount(data,'',theDiscount);
              });
            })
            .fail(function(error) {
              console.log(error);
              console.log('failed added');
            });
          }
        } else{
          cartLoading(false);
        }
    } else{
      $.getJSON( '/cart.js', function(data) {
        localStorage.setItem('discount', theDiscount);
        showDiscount(data,'',theDiscount);
        cartLoading(false);
      });
    }        
  }
};

function removeDiscount(){
  cartLoading(true);
  localStorage.removeItem('discount');
  $('#checkoutDiscount').val('');


  $('.cart__item[data-id="32801991393355"] .cart__item__info__price--free').hide();
  $('.cart__item[data-id="32801991393355"] .cart__item__info__price--original').show();
  $('.cart__item[data-id="32801991393355"] .cart__item__info__quantity button').show();

  $('.cart__item[data-id="32700172075083"] .cart__item__info__price--strikethrough').hide();

  $('.drawer__cart__discount__success').hide();
  $('.drawer__cart__discount__field').show();
  $('.drawer__cart__totals--savings').hide();
  $.getJSON( '/cart.js', function(data) {
    cartData.extra.cartSavings = 0;
    cartData.cart = data;
    cartLoading(false);
  });
}

function showDiscount(data,mode,discount){
    $('#checkoutDiscount').val(discount);

    if(discount == 'go50'){

      var scooterQuantity = 0;
      var scooterDiscount = 5000;
      var phoneHolderDiscount = 3900;
      for (var i = data.items.length - 1; i >= 0; i--) {
        if(data.items[i].id == 32700172075083){
          scooterQuantity = data.items[i].quantity;
        }
      }

      $.post('/cart/change.js', {
        quantity: scooterQuantity,
        id: 32801991393355,     
      },null,"json")
      .done(function(data) {
        $.getJSON( '/cart.js', function(data) {

          for (var i = data.items.length - 1; i >= 0; i--) {
            if(data.items[i].id == 32700172075083){
              data.items[i].price = data.items[i].price - scooterDiscount;
            }
          }
          data.total_price = data.total_price - (scooterQuantity * phoneHolderDiscount); // add 39€ discount
          data.total_price = data.total_price - (scooterQuantity * scooterDiscount); // add 50€ discount
          cartData.extra.cartSavings = (scooterQuantity * scooterDiscount) + phoneHolderDiscount; // show savings
          cartData.cart = data;



          if(mode != 'dataonly'){
            // hide input
            $('.drawer__cart__discount__field').hide();
            // show applied message
            $('.drawer__cart__discount__success').show();
            $('.drawer__cart__discount__success__msg').html('<strong>'+discount+'</strong> wurde berechnet').show();

            // show savings
            $('.drawer__cart__totals--savings').show();

            // hide mytier halterung price
            $('.cart__item[data-id="32801991393355"] .cart__item__info__price--free').show();
            $('.cart__item[data-id="32801991393355"] .cart__item__info__price--original').hide();
            $('.cart__item[data-id="32801991393355"] .cart__item__info__quantity button').hide();

            $('.cart__item[data-id="32700172075083"] .cart__item__info__price--strikethrough').show();
            
          }
          cartLoading(false);
        });
      })
      .fail(function(error) {
        console.log(error);
        console.log('failed added');
        cartLoading(false);
      });
      
     
    } else{
      // hide input
      $('.drawer__cart__discount__field').hide();
      // show applied message
      $('.drawer__cart__discount__success').show();
      $('.drawer__cart__discount__success__msg').html('<strong>'+discount+'</strong> wird im Checkout berechnet').show();
    }
}

//**** Check if sth is in the viewport *****//
function onVisibilityChange(el, callback) {
    var old_visible;
    return function () {
        var visible = isElementInViewport(el);
        if (visible != old_visible) {
            old_visible = visible;
            if (typeof callback == 'function') {
                callback();
            }
        }
    }
}



// CHRISTMAS SPECIAL

// // Array to store our Snowflake objects
//   var snowflakes = [];

//   // Global variables to store our browser's window size
//   var browserWidth;
//   var browserHeight;

//   // Specify the number of snowflakes you want visible
//   var numberOfSnowflakes = 20;

//   // Flag to reset the position of the snowflakes
//   var resetPosition = false;

//   // Handle accessibility
//   var enableAnimations = false;
//   var reduceMotionQuery = matchMedia("(prefers-reduced-motion)");

//   // Handle animation accessibility preferences 
//   function setAccessibilityState() {
//     if (reduceMotionQuery.matches) {
//       enableAnimations = false;
//     } else { 
//       enableAnimations = true;
//     }
//   }
//   setAccessibilityState();

//   reduceMotionQuery.addListener(setAccessibilityState);

//   //
//   // It all starts here...
//   //
//   function setup() {
//     if (enableAnimations) {
//       window.addEventListener("DOMContentLoaded", generateSnowflakes, false);
//       window.addEventListener("resize", setResetFlag, false);
//     }
//   }
//   setup();

//   //
//   // Constructor for our Snowflake object
//   //
//   function Snowflake(element, speed, xPos, yPos) {
//     // set initial snowflake properties
//     this.element = element;
//     this.speed = speed;
//     this.xPos = xPos;
//     this.yPos = yPos;
//     this.scale = 1;

//     // declare variables used for snowflake's motion
//     this.counter = 0;
//     this.sign = Math.random() < 0.5 ? 1 : -1;

//     // setting an initial opacity and size for our snowflake
//     this.element.style.opacity = (.4 + Math.random()) / 3;
//   }

//   //
//   // The function responsible for actually moving our snowflake
//   //
//   Snowflake.prototype.update = function () {
//     // using some trigonometry to determine our x and y position
//     this.counter += this.speed / 5000;
//     this.xPos += this.sign * this.speed * Math.cos(this.counter) / 40;
//     this.yPos += Math.sin(this.counter) / 40 + this.speed / 30;
//     this.scale = .5 + Math.abs(10 * Math.cos(this.counter) / 20);

//     // setting our snowflake's position
//     setTransform(Math.round(this.xPos), Math.round(this.yPos), this.scale, this.element);

//     // if snowflake goes below the browser window, move it back to the top
//     if (this.yPos > browserHeight) {
//       this.yPos = -50;
//     }
//   }

//   //
//   // A performant way to set your snowflake's position and size
//   //
//   function setTransform(xPos, yPos, scale, el) {
//     el.style.transform = `translate3d(${xPos}px, ${yPos}px, 0) scale(${scale}, ${scale})`;
//   }

//   //
//   // The function responsible for creating the snowflake
//   //
//   function generateSnowflakes() {

//     // get our snowflake element from the DOM and store it
//     var originalSnowflake = document.querySelector(".snowflake");

//     // access our snowflake element's parent container
//     var snowflakeContainer = originalSnowflake.parentNode;
//     snowflakeContainer.style.display = "block";

//     // get our browser's size
//     browserWidth = document.documentElement.clientWidth;
//     browserHeight = document.documentElement.clientHeight;

//     // create each individual snowflake
//     for (var i = 0; i < numberOfSnowflakes; i++) {

//       // clone our original snowflake and add it to snowflakeContainer
//       var snowflakeClone = originalSnowflake.cloneNode(true);
//       snowflakeContainer.appendChild(snowflakeClone);

//       // set our snowflake's initial position and related properties
//       var initialXPos = getPosition(50, browserWidth);
//       var initialYPos = getPosition(50, browserHeight);
//       var speed = 5 + Math.random() * 40;

//       // create our Snowflake object
//       var snowflakeObject = new Snowflake(snowflakeClone,
//         speed,
//         initialXPos,
//         initialYPos);
//       snowflakes.push(snowflakeObject);
//     }

//     // remove the original snowflake because we no longer need it visible
//     snowflakeContainer.removeChild(originalSnowflake);

//     moveSnowflakes();
//   }

//   //
//   // Responsible for moving each snowflake by calling its update function
//   //
//   function moveSnowflakes() {

//     if (enableAnimations) {
//       for (var i = 0; i < snowflakes.length; i++) {
//         var snowflake = snowflakes[i];
//         snowflake.update();
//       }      
//     }

//     // Reset the position of all the snowflakes to a new value
//     if (resetPosition) {
//       browserWidth = document.documentElement.clientWidth;
//       browserHeight = document.documentElement.clientHeight;

//       for (var i = 0; i < snowflakes.length; i++) {
//         var snowflake = snowflakes[i];

//         snowflake.xPos = getPosition(50, browserWidth);
//         snowflake.yPos = getPosition(50, browserHeight);
//       }

//       resetPosition = false;
//     }

//     requestAnimationFrame(moveSnowflakes);
//   }

//   //
//   // This function returns a number between (maximum - offset) and (maximum + offset)
//   //
//   function getPosition(offset, size) {
//     return Math.round(-1 * offset + Math.random() * (size + 2 * offset));
//   }

//   //
//   // Trigger a reset of all the snowflakes' positions
//   //
//   function setResetFlag(e) {
//     resetPosition = true;
//   }
